<template>
  <div class="shared-login-page">
    <div class="shared-login-card">
      <div class="loader loader--style3">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="70px"
          height="70px"
          viewBox="0 0 50 50"
          style="enable-background:new 0 0 50 50;"
          xml:space="preserve"
        >
          <path
            fill="#4F8AAB"
            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
          >
            <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="0.6s"
              repeatCount="indefinite"
            />
          </path>
        </svg>
      </div>
      <p class="title">Đang kiểm tra phiên đăng nhập dùng chung</p>
      <p class="description">
        Hệ thống sẽ tự chuyển tiếp sang Office hoặc trang đăng nhập nếu chưa có phiên hợp lệ.
      </p>
    </div>
  </div>
</template>

<script>
import SharedAuthService from "../../service/SharedAuthService";
import AuthBootstrapService from "../../service/AuthBootstrapService";

export default {
  async created() {
    const targetPath = SharedAuthService.resolveRedirectPath(
      this.$route.query.target || this.$route.query.redirect
    );
    const redirectQuery = {
      redirect: targetPath,
    };

    if (this.$route.query.source) {
      redirectQuery.source = this.$route.query.source;
    }

    SharedAuthService.hydrateLocalTokenFromSharedCookie();

    if (!SharedAuthService.hasLocalToken()) {
      this.$router.replace({
        name: "Auth-Login",
        query: redirectQuery,
      });
      return;
    }

    try {
      await AuthBootstrapService.ensureBootstrapped();
      this.$router.replace(targetPath);
    } catch (error) {
      SharedAuthService.clearSharedAuth();
      this.$router.replace({
        name: "Auth-Login",
        query: redirectQuery,
      });
    }
  },
};
</script>

<style scoped>
.shared-login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at top left, rgba(79, 138, 171, 0.15), transparent 40%),
    linear-gradient(135deg, #f6fbff, #eef4f8);
}

.shared-login-card {
  width: 100%;
  max-width: 420px;
  padding: 32px 28px;
  border-radius: 20px;
  text-align: center;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 24px 60px rgba(52, 89, 112, 0.14);
}

.title {
  margin: 18px 0 10px;
  font-size: 20px;
  font-weight: 700;
  color: #1f2f3d;
}

.description {
  margin: 0;
  color: #5d6c79;
  line-height: 1.6;
}
</style>
